import { FAQ_DATA } from "@/components/shared/FAQ";
import { HOME_DESCRIPTION, HOME_TITLE } from "@/lib/seo/site";
import type { HomeContent } from "../types";

export const EN_HOME: HomeContent = {
  seoTitle: HOME_TITLE,
  seoDescription: HOME_DESCRIPTION,
  heading: { prefix: "The", highlight: "#1 Clipping Tool", suffix: "Edit Viral Videos With AI" },
  body: "Your all-in-one tool for auto clipping, AI voiceovers, engaging subtitles, and more.",
  mobileBody: "Your all-in-one platform for editing.",
  faqs: FAQ_DATA,
};
